/* eslint-disable perfectionist/sort-enums */

export enum MetadataOrderOfApplication {
  First = 0,
  AfterValue = 1,
  AfterAdd = 2,
  AfterDefault = 3,
  AfterOneOf = 4,
  AfterSubsetOf = 5,
  Last = 6,
}
